export default function () { 
  (function ($) {
 
    const b = $("body");

    function open(e) {
      e.preventDefault();
      const t = $(this) 

      // Close all other modals 
      $(".active-modal").removeClass('active-modal')

      // If trigger just clicked to open
      if (t.hasClass("data-modal-toggle")) {

        t.removeClass("data-modal-toggle") 
        b.removeClass('open-modal') 

      } else {

        $(".data-modal-toggle").removeClass("data-modal-toggle")
        
        b.addClass('open-modal')
        t.addClass("data-modal-toggle") 
        const m = t.data("modal-target")
        $('#' + m).addClass('active-modal')
  
      }

    }

    function close(e) {
      e.preventDefault(); 
      $(".data-modal-toggle").removeClass("data-modal-toggle")
      b.removeClass('open-modal') 
      $('.active-modal').removeClass('active-modal')
    }


    $('[data-modal]').on('click', open)
    $('[data-modal-close]').on('click', close) 

 


  })(jQuery); 
};

 